import { createGlobalStyle } from "styled-components";

const MarketingPageStyles = createGlobalStyle`
.marketing-page {
  --orange: #f07a2a;
  --orange-dark: #d4611a;
  --orange-light: #ff9a52;
  --black: #0a0a0a;
  --black2: #111111;
  --black3: #1a1a1a;
  --white: #ffffff;
  --offwhite: #f9f8f6;
  --gray: #888888;
  --gray-light: #e8e6e1;
  --text-dark: #1a1a1a;
}
/* ─── LOGOS MARQUEE ─── */
.marquee-outer:hover .marquee-track { animation-play-state: paused; }

.logo-chip {
  display: flex;
  align-items: center;
  padding: 10px 22px;
  border-radius: 40px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  cursor: default;
  transition: all .3s;
  white-space: nowrap;
  flex-shrink: 0;
  border: 1px solid transparent;
}
.logo-chip.bk {
  background: #111;
  color: #fff;
  border-color: #111;
}
.logo-chip.og {
  background: #f07a2a;
  color: #fff;
  border-color: #f07a2a;
}
.logo-chip.bk:hover {
  background: #f07a2a;
  border-color: #f07a2a;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(240,122,42,0.2);
}
.logo-chip.og:hover {
  background: #d4611a;
  border-color: #d4611a;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(240,122,42,0.3);
}

@keyframes marqueeScroll {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.marketing-page *{margin:0;padding:0;box-sizing:border-box;}
/* html scroll handled globally */

.marketing-page {
  font-family:'Inter',sans-serif;
  background:var(--white);
  color:var(--text-dark);
  overflow-x:hidden;
  width:100%;
}



/* ─── LOADING SCREEN ─── */
.loader {
  position:fixed;inset:0;background:var(--black);z-index:9990;
  display:flex;align-items:center;justify-content:center;
  flex-direction:column;gap:20px;
}
.loader-logo {
  font-family:'Syne',sans-serif;font-size:28px;font-weight:800;
  color:var(--white);letter-spacing:0.02em;overflow:hidden;
}
.loader-logo span{color:var(--orange);}
.loader-bar-wrap{width:200px;height:2px;background:#2a2a2a;border-radius:2px;overflow:hidden;}
.loader-bar{height:100%;background:var(--orange);width:0%;transition:width .05s linear;}
.loader-num{font-size:12px;color:#555;font-weight:500;}
.loader.done{opacity:0;pointer-events:none;transition:opacity .6s ease .2s;}

/* ─── NAVBAR ─── */
.marketing-page nav {
  position:fixed;top:0;left:0;right:0;z-index:1000;
  padding:0 5%;
  background:transparent;
  transition:background .4s,backdrop-filter .4s,border-bottom .4s;
}
.marketing-page nav.scrolled {
  background:rgba(10,10,10,0.92);
  backdrop-filter:blur(20px);
  border-bottom:1px solid #1e1e1e;
}
.nav-inner{
  display:flex;align-items:center;justify-content:space-between;
  height:70px;
}
.nav-logo{display:flex;align-items:center;gap:10px;text-decoration:none;}
.nav-logo-img{
  height:40px;width:100;display:block;object-fit:contain;
}
.nav-links{display:flex;gap:32px;list-style:none;}
.nav-links a{
  font-size:13px;color:rgba(255,255,255,0.55);text-decoration:none;
  font-weight:500;letter-spacing:0.02em;
  transition:color .2s;position:relative;
}
.nav-links a::after{
  content:'';position:absolute;bottom:-4px;left:0;right:0;height:1px;
  background:var(--orange);transform:scaleX(0);transform-origin:left;
  transition:transform .3s;
}
.nav-links a:hover{color:var(--white);}
.nav-links a:hover::after{transform:scaleX(1);}
.nav-right{display:flex;gap:10px;align-items:center;}
.btn-ghost-nav{
  font-size:12px;color:rgba(255,255,255,0.6);
  padding:8px 16px;border:1px solid rgba(255,255,255,0.15);border-radius:7px;
  cursor:pointer;background:transparent;font-weight:500;
  transition:all .2s;
}
.btn-ghost-nav:hover{border-color:var(--orange);color:var(--white);}
.btn-orange{
  font-size:12px;color:var(--white);
  padding:8px 18px;border:none;border-radius:7px;
  cursor:pointer;background:var(--orange);font-weight:600;
  transition:all .2s;letter-spacing:0.02em;
}
.btn-orange:hover{background:var(--orange-dark);transform:translateY(-1px);}
.hamburger{display:none;flex-direction:column;gap:5px;cursor:pointer;padding:5px;}
.hamburger span{width:22px;height:1.5px;background:var(--white);border-radius:2px;transition:all .3s;}

/* ─── HERO ─── */
.hero {
  position:relative;height:100vh;min-height:680px;
  background:var(--black);overflow:hidden;
  display:flex;align-items:center;
}
.hero-bg-img {
  position:absolute;inset:0;
  background-image:url('https://images.unsplash.com/photo-1551434678-e076c223a692?w=1600&q=80');
  background-size:cover;background-position:center 30%;
  opacity:0.3;
  transform:scale(1.05);
  transition:transform 8s ease;
}
.hero-bg-img.loaded{transform:scale(1);}
.hero-overlay{
  position:absolute;inset:0;
  background:linear-gradient(105deg, rgba(10,10,10,0.97) 0%, rgba(10,10,10,0.75) 55%, rgba(10,10,10,0.3) 100%);
}
.hero-grid-lines {
  position:absolute;inset:0;
  background-image:
    linear-gradient(rgba(240,122,42,0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(240,122,42,0.04) 1px, transparent 1px);
  background-size:60px 60px;
}
.hero-content{
  position:relative;z-index:2;padding:0 5%;
  max-width:1280px;margin:0 auto;width:100%;
  display:grid;grid-template-columns:1fr 1fr;gap:60px;align-items:center;
}

/* FIX 10: Brand spine banner */
.brand-spine-bar {
  position:absolute;top:70px;left:0;right:0;z-index:99;
  background:rgba(240,122,42,0.08);
  border-bottom:1px solid rgba(240,122,42,0.15);
  text-align:center;
  padding:9px 5%;
}
.brand-spine-bar span {
  font-size:12px;color:rgba(255,255,255,0.55);
  letter-spacing:0.04em;font-weight:400;
  font-style:italic;
}
.brand-spine-bar strong {
  color:rgba(255,255,255,0.75);font-style:normal;
}

.hero-eyebrow {
  display:inline-flex;align-items:center;gap:8px;
  background:rgba(240,122,42,0.1);border:1px solid rgba(240,122,42,0.2);
  border-radius:30px;padding:6px 14px 6px 8px;margin-bottom:28px;
  opacity:0;transform:translateY(20px);
}
.hero-eyebrow.visible{animation:fadeUp .6s ease forwards;}
.eyebrow-dot{
  width:20px;height:20px;background:var(--orange);border-radius:50%;
  display:flex;align-items:center;justify-content:center;
}
.eyebrow-dot svg{width:10px;height:10px;fill:white;}
.hero-eyebrow span{font-size:11px;color:rgba(255,255,255,0.7);font-weight:500;letter-spacing:0.04em;}

.hero-h1 {
  font-family:'Syne',sans-serif;
  font-size:clamp(27px,5.5vw,68px);
  font-weight:600;color:var(--white);
  line-height:1.08;letter-spacing:-0.03em;
  margin-bottom:20px;
  margin-top:100px;
  opacity:0;transform:translateY(30px);
}
.hero-h1.visible{animation:fadeUp .7s ease .15s forwards;}
.hero-h1 em{color:var(--orange);font-style:normal;display:block;}

/* FIX 2: Hero subparagraph */
.hero-p {
  font-size:16px;color:rgba(255,255,255,0.5);line-height:1.75;
  max-width:420px;margin-bottom:36px;font-weight:400;
  opacity:0;transform:translateY(20px);
}
.hero-p.visible{animation:fadeUp .6s ease .3s forwards;}

.hero-btns{
  display:flex;gap:14px;flex-wrap:wrap;
  opacity:0;transform:translateY(20px);
}
.hero-btns.visible{animation:fadeUp .6s ease .45s forwards;}

.btn-hero-primary{
  display:inline-flex;align-items:center;gap:8px;
  background:var(--orange);color:var(--white);
  font-size:14px;font-weight:600;padding:14px 28px;
  border-radius:10px;text-decoration:none;
  border:none;cursor:pointer;letter-spacing:0.01em;
  transition:all .3s;position:relative;overflow:hidden;
}
.btn-hero-primary::before{
  content:'';position:absolute;inset:0;
  background:rgba(255,255,255,0.1);
  transform:translateX(-100%);transition:transform .3s;
}
.btn-hero-primary:hover::before{transform:translateX(0);}
.btn-hero-primary:hover{transform:translateY(-2px);}
.btn-hero-secondary{
  display:inline-flex;align-items:center;gap:8px;
  background:transparent;color:rgba(255,255,255,0.75);
  font-size:14px;font-weight:500;padding:14px 24px;
  border-radius:10px;border:1px solid rgba(255,255,255,0.15);
  cursor:pointer;transition:all .3s;text-decoration:none;
}
.btn-hero-secondary:hover{border-color:var(--orange);color:var(--white);}

.hero-trust {
  display:flex;gap:24px;margin-top:36px;flex-wrap:wrap;
  opacity:0;
}
.hero-trust.visible{animation:fadeUp .5s ease .6s forwards;}
.trust-item{display:flex;align-items:center;gap:6px;}
.trust-check{
  width:16px;height:16px;background:rgba(34,197,94,0.15);
  border-radius:50%;display:flex;align-items:center;justify-content:center;
}
.trust-check svg{width:9px;height:9px;stroke:#22c55e;fill:none;stroke-width:2.5;}
.trust-item span{font-size:12px;color:rgba(255,255,255,0.45);font-weight:400;}

.hero-right {
  position:relative;
  opacity:0;transform:translateX(40px);
}
.hero-right.visible{animation:fadeRight .8s ease .3s forwards;}

.dashboard-card {
  background:#111;border:1px solid #222;border-radius:16px;
  overflow:hidden;
}
.dash-bar {
  background:#161616;padding:14px 18px;
  border-bottom:1px solid #1e1e1e;
  display:flex;align-items:center;justify-content:space-between;
}
.dash-bar-dots{display:flex;gap:6px;}
.dot{width:10px;height:10px;border-radius:50%;}
.dash-metrics-grid{
  display:grid;grid-template-columns:repeat(3,1fr);
  gap:1px;background:#1a1a1a;
}
.dash-metric{
  background:#111;padding:18px;
}
.dm-l{font-size:10px;color:#555;margin-bottom:5px;font-weight:500;text-transform:uppercase;letter-spacing:0.06em;}
.dm-v{font-size:22px;font-weight:700;color:var(--white);}
.dm-v.g{color:#22c55e;}
.dm-v.o{color:var(--orange);}
.dm-s{font-size:10px;color:#444;margin-top:3px;}
.dash-orders{padding:16px 18px;}
.dash-orders-head{
  display:flex;justify-content:space-between;align-items:center;
  margin-bottom:12px;
}
.dash-orders-title{font-size:12px;font-weight:600;color:#888;}
.dash-orders-link{font-size:11px;color:var(--orange);}
.order-row{
  display:flex;align-items:center;justify-content:space-between;
  padding:9px 0;border-bottom:1px solid #181818;
}
.order-row:last-child{border:none;}
.order-id{font-size:11px;color:#666;font-family:'Inter',monospace;}
.order-dest{font-size:11px;color:#555;}
.order-status{font-size:10px;padding:3px 9px;border-radius:4px;font-weight:500;}
.s-del{background:#0a2010;color:#4ade80;}
.s-tra{background:#1e1200;color:#f59e0b;}
.s-pro{background:#0a1a2a;color:#60a5fa;}
.order-time{font-size:10px;color:#3a3a3a;}

.notif-float {
  position:absolute;bottom:-16px;left:-20px;
  background:#111;border:1px solid #222;border-radius:12px;
  padding:12px 16px;display:flex;align-items:center;gap:10px;
  min-width:200px;
  animation:floatBob 3s ease-in-out infinite;
}
.notif-icon-box{
  width:32px;height:32px;background:#0a2010;border-radius:8px;
  display:flex;align-items:center;justify-content:center;
}
.notif-icon-box svg{width:16px;height:16px;stroke:#4ade80;fill:none;stroke-width:2;}
.notif-texts{}
.notif-title{font-size:11px;color:var(--white);font-weight:500;}
.notif-sub{font-size:10px;color:#555;margin-top:1px;}

.hero-scroll-hint {
  position:absolute;bottom:36px;left:50%;transform:translateX(-50%);
  display:flex;flex-direction:column;align-items:center;gap:8px;
  opacity:0;animation:fadeIn 1s ease 1.2s forwards;
}
.scroll-line{
  width:1px;height:40px;background:rgba(255,255,255,0.1);
  position:relative;overflow:hidden;
}
.scroll-line::after{
  content:'';position:absolute;top:-40px;left:0;
  width:1px;height:40px;background:var(--orange);
  animation:scrollDrop 1.5s ease infinite;
}
.scroll-text{font-size:10px;color:#444;letter-spacing:0.1em;text-transform:uppercase;}

/* ─── SECTION BASE ─── */
.marketing-page section{padding:100px 5%;}
.section-inner{max-width:1280px;margin:0 auto;}
.section-full{padding:100px 5%;}
.section-full > *{max-width:1280px;margin:0 auto;}

/* ─── PROBLEM SECTION ─── */
.problem-section{background:var(--white);max-width:1280px;margin:0 auto;}
.problem-inner{display:grid;grid-template-columns:1fr 1fr;gap:80px;align-items:center;}
.section-eyebrow{
  display:inline-block;font-size:11px;font-weight:600;color:var(--orange);
  letter-spacing:0.1em;text-transform:uppercase;margin-bottom:16px;
}
.section-h2{
  font-family:'Syne',sans-serif;
  font-size:clamp(28px,3.5vw,44px);font-weight:800;
  color:var(--text-dark);line-height:1.15;letter-spacing:-0.02em;
  margin-bottom:20px;
}
.section-h2 em{color:var(--orange);font-style:normal;}
.section-p{font-size:15px;color:#666;line-height:1.8;margin-bottom:28px;}

.pain-list{display:flex;flex-direction:column;gap:14px;}
.pain-item{
  display:flex;align-items:flex-start;gap:14px;
  padding:16px;background:var(--offwhite);border-radius:10px;
  border:1px solid var(--gray-light);
  transition:border-color .2s,transform .2s;
}
.pain-item:hover{border-color:var(--orange);transform:translateX(4px);}
.pain-icon{
  width:36px;height:36px;background:#fff0e8;border-radius:8px;
  display:flex;align-items:center;justify-content:center;flex-shrink:0;
}
.pain-icon svg{width:18px;height:18px;stroke:var(--orange);fill:none;stroke-width:1.8;}
.pain-text{font-size:13px;color:#555;line-height:1.6;font-style:italic;}
.pain-text strong{color:var(--text-dark);font-style:normal;}

.problem-visual{position:relative;}
.problem-img-wrap{
  border-radius:16px;overflow:hidden;position:relative;
  background:#1a1a1a;aspect-ratio:4/3;
}
.problem-img{
  width:100%;height:100%;
  object-fit:cover;
  display:block;
  opacity:0.85;
}
.problem-stat-card{
  position:absolute;bottom:-20px;right:-20px;
  background:var(--black);border:1px solid #2a2a2a;border-radius:12px;
  padding:16px 20px;min-width:160px;
}
.psc-num{font-family:'Syne',sans-serif;font-size:32px;font-weight:800;color:var(--orange);}
.psc-label{font-size:12px;color:#555;margin-top:2px;}

/* ─── HOW IT WORKS ─── */
.how-section{background:#f5f4f1;padding:100px 5%;}
.how-inner{max-width:1280px;margin:0 auto;}
.how-header{text-align:center;max-width:580px;margin:0 auto 60px;}

.flip-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;}
.flip-wrap{height:220px;perspective:1000px;cursor:default;}
.flip-inner{position:relative;width:100%;height:100%;transition:transform .7s cubic-bezier(.4,0,.2,1);transform-style:preserve-3d;}
.flip-wrap:hover .flip-inner{transform:rotateY(180deg);}
.flip-front,.flip-back{position:absolute;inset:0;backface-visibility:hidden;border-radius:14px;overflow:hidden;}

.flip-front{border:1px solid #ddd;}
.f-img{position:absolute;inset:0;background-size:cover;background-position:center;transition:transform .7s ease;}
.flip-wrap:hover .f-img{transform:scale(1.06);}
.f-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(150deg, rgba(0,0,0,0.70) 90%, rgba(0,0,0,0.50) 100%);
}
.f-content{position:relative;z-index:2;padding:20px;height:100%;display:flex;flex-direction:column;justify-content:space-between;}
.f-top{display:flex;align-items:center;justify-content:space-between;}
.f-num{font-size:34px;font-weight:900;color:#ffffff;line-height:1;}
.f-icon{width:38px;height:38px;background:rgba(240,122,42,0.15);border-radius:9px;display:flex;align-items:center;justify-content:center;border:1px solid rgba(240,122,42,0.25);}
.f-icon svg{width:18px;height:18px;stroke:#f07a2a;fill:none;stroke-width:1.8;}
.f-title{font-size:15px;font-weight:700;color:#ffffff;line-height:1.3;}
.f-badge{display:inline-block;margin-top:5px;font-size:10px;font-weight:700;color:#f07a2a;background:rgba(240,122,42,0.1);padding:2px 9px;border-radius:20px;border:1px solid rgba(240,122,42,0.2);}

.flip-back{transform:rotateY(180deg);}
.b-img{position:absolute;inset:0;background-size:cover;background-position:center;opacity:0.15;}
.b-overlay{position:absolute;inset:0;background:#f07a2a;}
.b-content{position:relative;z-index:2;padding:22px;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;gap:8px;}
.b-num{font-size:44px;font-weight:900;color:rgba(0,0,0,1);line-height:1;}
.b-desc{font-size:12px;color:rgba(255,255,255,0.95);line-height:1.7;}

/* ─── FEATURES ─── */
.features-section{background:#faf9f7;padding:100px 5%;max-width:100% !important;margin:0 !important;}
.features-header{text-align:center;max-width:580px;margin:0 auto 60px;}
.features-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;max-width:1280px;margin:0 auto;}

.feat-card{
  background:#fff;border:1px solid #eee;border-radius:16px;
  padding:0;cursor:default;overflow:hidden;
  transition:all .4s cubic-bezier(.4,0,.2,1);
  position:relative;
}
.feat-card:hover{
  border-color:#f07a2a;
  transform:translateY(-6px);
  box-shadow:0 20px 50px rgba(240,122,42,0.12);
}
.feat-top{
  padding:22px 22px 16px;
  border-bottom:1px solid #f5f5f5;
  display:flex;align-items:center;gap:12px;
  transition:border-color .4s;
}
.feat-card:hover .feat-top{border-color:#fff0e8;}
.feat-icon{
  width:40px;height:40px;
  background:#f9f7f5;border-radius:10px;
  display:flex;align-items:center;justify-content:center;
  flex-shrink:0;border:1px solid #eee;
  transition:all .4s;
}
.feat-card:hover .feat-icon{background:#f07a2a;border-color:#f07a2a;}
.feat-icon svg{width:18px;height:18px;stroke:#bbb;fill:none;stroke-width:1.8;transition:stroke .4s;}
.feat-card:hover .feat-icon svg{stroke:#fff;}
.feat-title{font-size:13px;font-weight:700;color:#111;line-height:1.3;}
.feat-bottom{padding:16px 22px 22px;}
.feat-desc{font-size:12px;color:#aaa;line-height:1.7;margin-bottom:14px;}
.feat-bar-wrap{height:3px;background:#f0eeeb;border-radius:3px;overflow:hidden;}
.feat-bar{
  height:100%;
  background:linear-gradient(90deg,#f07a2a,#ff9a52);
  border-radius:3px;width:0%;
  transition:width .8s cubic-bezier(.4,0,.2,1);
}
.feat-card:hover .feat-bar{width:var(--w,75%);}

/* ─── MARGIN SECTION (FIX 4 — new section) ─── */
.margin-section{background:var(--black);padding:100px 5%;}
.margin-inner{max-width:1280px;margin:0 auto;}
.margin-grid{display:grid;grid-template-columns:1fr 1fr;gap:60px;align-items:center;}
.margin-pain-list{display:flex;flex-direction:column;gap:14px;margin-top:28px;}
.margin-pain-item{
  display:flex;align-items:flex-start;gap:14px;
  padding:16px;background:#161616;border-radius:10px;
  border:1px solid #222;
  transition:border-color .2s;
}
.margin-pain-item:hover{border-color:var(--orange);}
.margin-pain-icon{
  width:36px;height:36px;background:rgba(240,122,42,0.1);border-radius:8px;
  display:flex;align-items:center;justify-content:center;flex-shrink:0;
}
.margin-pain-icon svg{width:18px;height:18px;stroke:var(--orange);fill:none;stroke-width:1.8;}
.margin-pain-text{font-size:13px;color:#666;line-height:1.6;font-style:italic;}
.margin-pain-text strong{color:#ccc;font-style:normal;}
.margin-right{display:flex;flex-direction:column;gap:20px;}
.margin-card{
  background:#111;border:1px solid #1e1e1e;border-radius:14px;
  padding:24px;
}
.margin-card-label{font-size:11px;color:#555;letter-spacing:0.08em;margin-bottom:8px;}
.margin-card-value{font-family:'Syne',sans-serif;font-size:28px;font-weight:800;color:var(--orange);}
.margin-card-sub{font-size:13px;color:#444;margin-top:6px;line-height:1.6;}

/* ─── COMPARISON SECTION ─── */
.compare-section{background:var(--offwhite);padding:100px 5%;}
.compare-inner{max-width:1000px;margin:0 auto;}
.compare-header{text-align:center;margin-bottom:50px;}
.compare-table{
  background:var(--white);border-radius:16px;overflow:hidden;
  border:1px solid var(--gray-light);width:100%;
}
.compare-head{
  display:grid;grid-template-columns:2fr 1fr 1fr;
  background:var(--text-dark);
}
.ch-item{padding:16px 24px;font-size:13px;font-weight:600;color:rgba(255,255,255,0.5);}
.ch-item.highlight{color:var(--orange);}
.compare-row{
  display:grid;grid-template-columns:2fr 1fr 1fr;
  border-bottom:1px solid var(--gray-light);
}
.compare-row:last-child{border:none;}
.cr-item{padding:14px 24px;font-size:13px;color:#666;display:flex;align-items:center;gap:8px;}
.cr-item.feature{color:var(--text-dark);font-weight:500;}
.check-y svg{width:16px;height:16px;stroke:#22c55e;fill:none;stroke-width:2.5;}
.check-n svg{width:16px;height:16px;stroke:#e24b4a;fill:none;stroke-width:2.5;}
.check-o svg{width:16px;height:16px;stroke:var(--orange);fill:none;stroke-width:2.5;}

/* ─── SOCIAL PROOF ─── */
.reviews-section{background:var(--white);padding:100px 5%;max-width:100% !important;margin:0 !important;}
.reviews-header{text-align:center;max-width:520px;margin:0 auto 52px;}
.reviews-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;max-width:1280px;margin:0 auto;}

.review-card{
  background:#111111;
  border:1px solid #222;
  border-radius:18px;
  padding:28px;
  position:relative;
  overflow:hidden;
  opacity:0;
  transform:translateY(50px);
  transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s cubic-bezier(.22,1,.36,1),border-color .3s,box-shadow .4s;
  cursor:default;
}
.review-card.visible{opacity:1;transform:translateY(0);}
.review-card::before{
  content:'';position:absolute;top:0;left:0;right:0;height:2px;
  background:var(--orange);
  transform:scaleX(0);transform-origin:left;
  transition:transform .5s cubic-bezier(.22,1,.36,1);
}
.review-card:hover::before{transform:scaleX(1);}
.review-card:hover{
  border-color:rgba(240,122,42,0.27);
  box-shadow:0 0 0 1px rgba(240,122,42,0.13),0 20px 50px rgba(240,122,42,0.12);
}
.review-shine{
  position:absolute;inset:0;border-radius:18px;pointer-events:none;
  background:radial-gradient(circle at 50% 0%,rgba(240,122,42,0.07) 0%,transparent 60%);
  opacity:0;transition:opacity .4s;
}
.review-card:hover .review-shine{opacity:1;}
.review-stars{color:var(--orange);font-size:14px;margin-bottom:14px;letter-spacing:2px;}
.review-text{font-size:13.5px;color:#999;line-height:1.8;font-style:italic;margin-bottom:16px;transition:color .3s;}
.review-card:hover .review-text{color:#ccc;}
/* FIX 7: transformation line */
.review-transform{
  font-size:12px;color:var(--orange);font-weight:600;
  margin-bottom:20px;padding:8px 12px;
  background:rgba(240,122,42,0.08);border-radius:6px;
  border-left:2px solid var(--orange);
}
.review-author{
  display:flex;align-items:center;gap:12px;
  margin-bottom:0;padding-bottom:0;
  border-bottom:none;
  transition:border-color .3s;
}
.avatar{
  width:42px;height:42px;border-radius:50%;background:var(--orange);
  display:flex;align-items:center;justify-content:center;
  font-size:12px;font-weight:700;color:var(--white);flex-shrink:0;
  transition:transform .4s cubic-bezier(.34,1.56,.64,1);
}
.review-card:hover .avatar{transform:scale(1.12);}
.author-name{font-size:14px;font-weight:700;color:#ffffff;}
.author-role{font-size:11px;color:#555;margin-top:2px;}

/* ─── STATS ─── */
.stats-section{
  background:var(--black);padding:80px 5%;
}
.stats-inner{
  max-width:1280px;margin:0 auto;
  display:grid;grid-template-columns:repeat(4,1fr);
  gap:1px;
  background:#1e1e1e;border-radius:16px;overflow:hidden;
  border:1px solid #1e1e1e;
}
.stat-card{
  background:var(--black2);padding:40px 20px;text-align:center;
}
.stat-num{
  font-family:'Syne',sans-serif;font-size:clamp(28px,4vw,44px);font-weight:800;
  color:var(--orange);margin-bottom:8px;word-break:break-word;
}
.stat-label{font-size:13px;color:#555;line-height:1.5;}

/* ─── PRICING ─── */
.pricing-section{background:var(--white);padding:100px 5%;max-width:100% !important;margin:0 !important;}
.pricing-header{text-align:center;max-width:520px;margin:0 auto 50px;}
.pricing-grid{display:grid;grid-template-columns:repeat(2,minmax(280px,400px));gap:20px;align-items:stretch;max-width:1280px;margin:0 auto;justify-content:center;}
.pricing-card{
  background:var(--white);border:1px solid var(--gray-light);
  border-radius:16px;padding:32px;transition:all .3s;
  display:flex;flex-direction:column;}
.pricing-card.featured{
  border:2px solid var(--orange);transform:translateY(-8px);
  position:relative;
}
.pricing-card:hover:not(.featured){border-color:#ccc;transform:translateY(-4px);}
.pricing-badge{
  position:absolute;top:-14px;left:50%;transform:translateX(-50%);
  background:var(--orange);color:var(--white);
  font-size:11px;font-weight:600;padding:4px 14px;border-radius:20px;
  white-space:nowrap;
}
.pricing-plan{font-size:12px;font-weight:600;color:var(--gray);text-transform:uppercase;letter-spacing:0.08em;margin-bottom:12px;}
.pricing-price{margin-bottom:6px;}
.pricing-price .amount{
  font-family:'Syne',sans-serif;font-size:40px;font-weight:800;color:var(--text-dark);
}
.pricing-price .per{font-size:14px;color:#aaa;margin-left:2px;}
.pricing-desc{font-size:13px;color:#888;margin-bottom:24px;line-height:1.6;}
.pricing-features{list-style:none;margin-bottom:20px;display:flex;flex-direction:column;gap:10px;flex:1;}
.pricing-features li{display:flex;align-items:center;gap:8px;font-size:13px;color:#555;}
.pricing-features li svg{width:15px;height:15px;stroke:#22c55e;fill:none;stroke-width:2.5;flex-shrink:0;}
/* FIX 9: cancel anytime trust signal per card */
.pricing-trust{
  display:flex;align-items:center;gap:6px;
  padding:10px 12px;background:#f9f8f6;border-radius:7px;
  margin-bottom:20px;
}
.pricing-trust svg{width:13px;height:13px;stroke:#22c55e;fill:none;stroke-width:2.5;flex-shrink:0;}
.pricing-trust span{font-size:11px;color:#888;}
.btn-plan{
  width:100%;padding:12px;border-radius:8px;font-size:13px;font-weight:600;
  cursor:pointer;transition:all .2s;border:none;
}
.btn-plan-outline{background:transparent;color:var(--text-dark);border:1.5px solid var(--gray-light);}
.btn-plan-outline:hover{border-color:var(--orange);color:var(--orange);}
.btn-plan-fill{background:var(--orange);color:var(--white);}
.btn-plan-fill:hover{background:var(--orange-dark);}

/* ─── FAQ ─── */
.faq-section{background:var(--white);padding:100px 5%;}
.faq-inner{max-width:800px;margin:0 auto;}
.faq-head{text-align:center;margin-bottom:50px;}
.faq-list{display:flex;flex-direction:column;gap:10px;}
.faq-item{border-radius:12px;overflow:hidden;}
.faq-q{display:flex;align-items:center;justify-content:space-between;padding:20px 24px;cursor:pointer;gap:16px;background:var(--black2);}
.faq-q-text{font-size:15px;font-weight:600;color:var(--white);line-height:1.4;}
.faq-icon{width:30px;height:30px;min-width:30px;border-radius:50%;border:1px solid #333;display:flex;align-items:center;justify-content:center;transition:all .3s;}
.faq-icon svg{width:14px;height:14px;stroke:#666;stroke-width:2;fill:none;transition:stroke .3s;}
.faq-item.open .faq-icon{background:var(--orange);border-color:var(--orange);transform:rotate(45deg);}
.faq-item.open .faq-icon svg{stroke:var(--white);}
.faq-a{max-height:0;overflow:hidden;transition:max-height .4s cubic-bezier(.4,0,.2,1),opacity .3s;opacity:0;background:var(--orange);}
.faq-item.open .faq-a{max-height:300px;opacity:1;}
.faq-a-inner{padding:20px 24px;font-size:14px;color:var(--white);line-height:1.75;}

/* ─── CTA SECTION ─── */
.cta-section{
  background:var(--black);padding:100px 5%;
  position:relative;overflow:hidden;
}
.cta-bg{
  position:absolute;inset:0;
  background-image:url('https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1400&q=70');
  background-size:cover;background-position:center;
  opacity:0.06;
}
.cta-inner{
  position:relative;z-index:2;
  max-width:700px;margin:0 auto;text-align:center;
}
.cta-h2{
  font-family:'Syne',sans-serif;
  font-size:clamp(32px,4.5vw,54px);font-weight:800;
  color:var(--white);line-height:1.15;letter-spacing:-0.02em;
  margin-bottom:16px;
}
.cta-h2 em{color:var(--orange);font-style:normal;}
.cta-p{font-size:16px;color:rgba(255,255,255,0.45);margin-bottom:36px;line-height:1.7;}
.cta-btns{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;}
.cta-note{font-size:12px;color:#555;margin-top:16px;}

/* ─── FOOTER ─── */
.marketing-page footer{background:var(--black);border-top:1px solid #1a1a1a;padding:60px 5% 32px;}
.footer-inner{max-width:1280px;margin:0 auto;}
.footer-top{
  display:grid;grid-template-columns:2fr 1fr 1fr 1fr;gap:48px;
  margin-bottom:48px;
}
.footer-logo{display:flex;align-items:center;gap:8px;margin-bottom:16px;}
.footer-logo-box{width:28px;height:28px;background:var(--orange);border-radius:6px;display:flex;align-items:center;justify-content:center;}
.footer-logo-box svg{width:14px;height:14px;fill:white;}
.footer-logo-text{font-family:'Syne',sans-serif;font-size:14px;font-weight:800;color:var(--white);}
.footer-logo-text span{color:var(--orange);}
.footer-tagline{font-size:13px;color:#444;line-height:1.7;max-width:240px;}
.footer-col-title{font-size:12px;font-weight:600;color:rgba(255,255,255,0.4);text-transform:uppercase;letter-spacing:0.08em;margin-bottom:18px;}
.footer-links{list-style:none;display:flex;flex-direction:column;gap:10px;}
.footer-links a{font-size:13px;color:#555;text-decoration:none;transition:color .2s;}
.footer-links a:hover{color:var(--orange);}
.footer-bottom{
  border-top:1px solid #151515;padding-top:24px;
  display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:12px;
}
.footer-copy{font-size:12px;color:#444;}
.footer-socials{display:flex;gap:12px;}
.social-btn{
  width:32px;height:32px;border:1px solid #222;border-radius:7px;
  display:flex;align-items:center;justify-content:center;cursor:pointer;
  transition:all .2s;
}
.social-btn:hover{border-color:var(--orange);}
.social-btn svg{width:14px;height:14px;stroke:#555;fill:none;stroke-width:1.8;}
.social-btn:hover svg{stroke:var(--orange);}

/* ─── ANIMATIONS ─── */
@keyframes fadeUp {
  from{opacity:0;transform:translateY(20px);}
  to{opacity:1;transform:translateY(0);}
}
@keyframes fadeRight {
  from{opacity:0;transform:translateX(40px);}
  to{opacity:1;transform:translateX(0);}
}
@keyframes fadeIn {
  from{opacity:0;}to{opacity:1;}
}
@keyframes floatBob {
  0%,100%{transform:translateY(0);}
  50%{transform:translateY(-8px);}
}
@keyframes scrollDrop {
  0%{top:-40px;}100%{top:40px;}
}

.reveal {
  opacity:0;transform:translateY(32px);
  transition:opacity .7s ease,transform .7s ease;
}
.reveal.visible{opacity:1;transform:translateY(0);}
.reveal-left{opacity:0;transform:translateX(-32px);transition:opacity .7s ease,transform .7s ease;}
.reveal-left.visible{opacity:1;transform:translateX(0);}
.reveal-right{opacity:0;transform:translateX(32px);transition:opacity .7s ease,transform .7s ease;}
.reveal-right.visible{opacity:1;transform:translateX(0);}

.stagger-1{transition-delay:.1s!important;}
.stagger-2{transition-delay:.2s!important;}
.stagger-3{transition-delay:.3s!important;}
.stagger-4{transition-delay:.4s!important;}
.stagger-5{transition-delay:.5s!important;}

/* ─── MOBILE ─── */
@media(max-width:900px){
  .nav-links,.nav-right{display:none;}
  .hamburger{display:flex;}
  .marketing-page nav.menu-open .nav-links{
    display:flex;flex-direction:column;
    position:absolute;top:70px;left:0;right:0;
    background:rgba(10,10,10,0.98);
    padding:24px 5% 0 5%;gap:16px;
    z-index:999;align-items:flex-start;
    border-bottom:none;
  }
  .marketing-page nav.menu-open .nav-right{
    display:flex;flex-direction:column;
    position:absolute;top:70px;left:0;right:0;
    padding:0 5% 24px;
    background:rgba(10,10,10,0.98);gap:10px;
    margin-top:0;z-index:998;align-items:stretch;
    /* pushed down by JS — use padding-top trick instead */
  }
  .marketing-page nav.menu-open .btn-ghost-nav,
  .marketing-page nav.menu-open .btn-orange{
    width:100%;text-align:center;display:block;
  }
  .hero-content{grid-template-columns:1fr;gap:40px;padding-top:80px;}
  .hero-right{display:none;}
  .hero-h1{font-size:clamp(28px,8vw,42px);margin-top:20px;}
  .hero-p{font-size:14px;}
  .problem-inner{grid-template-columns:1fr;gap:40px;}
  .problem-stat-card{right:0;bottom:-10px;}
  .flip-grid{grid-template-columns:1fr 1fr;gap:8px;}
  .features-grid{grid-template-columns:1fr 1fr;gap:14px;}
  .reviews-grid{grid-template-columns:1fr;gap:14px;}
  .stats-inner{grid-template-columns:1fr 1fr;border-radius:12px;}
  .stat-card{padding:28px 16px;}
  .pricing-grid{grid-template-columns:1fr;gap:16px;}
  .pricing-card.featured{transform:none;}
  .footer-top{grid-template-columns:1fr 1fr;gap:32px;}
  .compare-table{overflow:hidden;border-radius:10px;}
  .compare-head,.compare-row{grid-template-columns:1.8fr 1fr 1fr;}
  .ch-item{padding:12px 10px;font-size:11px;}
  .cr-item{padding:10px 10px;font-size:11px;gap:4px;}
  .check-y svg,.check-n svg,.check-o svg{width:12px;height:12px;}
  .margin-grid{grid-template-columns:1fr;gap:40px;}
  .brand-spine-bar{display:none;}
  .cta-h2{font-size:clamp(26px,7vw,40px);}
  .section-h2{font-size:clamp(24px,6vw,38px);}
  .how-inner{padding:60px 5%;}
  .loader-logo{font-size:22px;}
  .loader-bar-wrap{width:160px;}
}
@media(max-width:560px){
  .marketing-page section{padding:60px 5%;}
  .section-full{padding:60px 5%;}
  .features-grid{grid-template-columns:1fr;}
  .flip-grid{grid-template-columns:1fr;gap:8px;}
  .faq-section{padding:60px 5%;}
  .faq-q{padding:16px 16px;}
  .faq-q-text{font-size:14px;}
  .faq-a-inner{padding:16px;}
  .stats-inner{grid-template-columns:1fr 1fr;border-radius:10px;}
  .stat-card{padding:24px 12px;}
  .stat-label{font-size:11px;}
  .footer-top{grid-template-columns:1fr;gap:24px;}
  .hero-trust{flex-direction:column;gap:10px;}
  .margin-right{gap:14px;}
  .margin-grid{gap:28px;}
  .hero-btns{flex-direction:column;gap:10px;}
  .btn-hero-primary,.btn-hero-secondary{width:100%;justify-content:center;}
  .cta-btns{flex-direction:column;align-items:center;}
  .compare-head,.compare-row{grid-template-columns:1.6fr 1fr 1fr;}
  .ch-item{padding:10px 8px;font-size:10px;}
  .cr-item{padding:8px 8px;font-size:10px;}
  .pricing-section,.reviews-section,.features-section{padding:60px 5%;}
  .pricing-grid{grid-template-columns:1fr;gap:14px;}
  .pricing-card.featured{transform:none;margin-top:0;}
  .stats-section{padding:60px 5%;}
  .compare-section .compare-inner{padding:60px 5%;}
  .notif-float{display:none;}
  .marketing-page nav{padding:0 4%;}
  .loader-logo{font-size:20px;}
  .loader-bar-wrap{width:140px;}
}

@media(prefers-reduced-motion:reduce){
  .marketing-page *{animation-duration:.01ms!important;transition-duration:.01ms!important;}
}

`;

export default MarketingPageStyles;
